import { render, staticRenderFns } from "./webForm.vue?vue&type=template&id=384f997a&"
import script from "./webForm.js?vue&type=script&lang=js&"
export * from "./webForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports